import React from 'react';
import styles from '../../Invoicing.module.css';

const HowItWorks = () => (
  <section className={styles.sec} id="how">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />How it works</span>
        <h2>From draft to deposited.</h2>
        <p className={styles.secLead}>Build an invoice, send it, and get paid online — without chasing anyone down.</p>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>01</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16v16H4z" /><path d="M8 9h8M8 13h5" /><path d="M8 17h3" />
            </svg>
          </div>
          <h3>Build a branded invoice</h3>
          <p>Add line items, your logo, and a due date in seconds. Save it as a template to reuse later.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>02</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="m4 4 16 8-16 8 4-8z" />
            </svg>
          </div>
          <h3>Send it your way</h3>
          <p>Deliver by email, text, or a shareable link — each with a Pay Now button built in.</p>
        </div>
        <div className={`${styles.step} ${styles.sr}`} data-sr>
          <div className={styles.stepN}>03</div>
          <div className={styles.stepIc}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#FF5A36" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v12m0 0-4-4m4 4 4-4M5 21h14" />
            </svg>
          </div>
          <h3>Get paid &amp; reconciled</h3>
          <p>Your customer pays online and the payment and receipt are logged automatically.</p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
